export const styles = theme => ({
  card: {
    margin: "4px 0",
    "& p": {
      margin: 0
    },
    cursor: "pointer"
  },
  cardRoot: {
    padding: theme.spacing.unit * 2
    // "&:last-child": {
    //   paddingBottom: 0
    // }
  },
  expand: {
    transform: "rotate(0deg)",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: "rotate(180deg)"
  },
  avatar: {
    backgroundColor: "#4285F4"
  },
  flexGrow: {
    flex: "1 1 auto"
  },
  navLink: {
    "&:focus": {
      outline: "none"
    },
    "&:hover": {
      color: "black"
    }
  },
  rootCardActionItem: { width: "35px", height: "35px" },
  colorPrimary: {
    color: "rgba(0, 0, 0, 0.35)"
  }
});



// WEBPACK FOOTER //
// ./src/library/card/item-card/styles.js